const steps = [
  {
    num: "01",
    title: "Discovery",
    desc: "We begin by understanding your vision, goals, site conditions, and project requirements — building a clear foundation before any design begins.",
    icon: "ri-search-eye-line",
    img: "https://www.archiconservices.com/img/home-projects/daria.jpg",
  },
  {
    num: "02",
    title: "Concept Design",
    desc: "Develop layout, spatial structure, and visual direction. This is where ideas take shape — translated into early sketches and design frameworks.",
    icon: "ri-pencil-ruler-2-line",
    img: "https://www.archiconservices.com/img/home-projects/anjali.jpg",
  },
  {
    num: "03",
    title: "Design Development",
    desc: "Refine every detail and prepare comprehensive plans. Materials, dimensions, and technical specifications are resolved into a complete design package.",
    icon: "ri-file-list-2-line",
    img: "https://www.archiconservices.com/img/feature-pic.jpg",
  },
  {
    num: "04",
    title: "Execution Support",
    desc: "Provide guidance and documentation through construction and implementation — ensuring the built result matches the design intent.",
    icon: "ri-building-4-line",
    img: "https://www.archiconservices.com/img/home-projects/residential.jpg",
  },
];

export default function Process() {
  return (
    <section id="process" className="py-28 px-6 bg-stone-900 relative overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 40px, rgba(255,255,255,0.3) 40px, rgba(255,255,255,0.3) 41px), repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(255,255,255,0.3) 40px, rgba(255,255,255,0.3) 41px)`,
          }}
        />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p
            className="text-xs tracking-widest uppercase text-amber-400 mb-3"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            How We Work
          </p>
          <h2
            className="text-4xl md:text-5xl font-light text-white leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            A Refined Design{" "}
            <em className="not-italic font-semibold">Process</em>
          </h2>
        </div>

        {/* Steps grid with images */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((step, i) => (
            <div
              key={i}
              className="group relative overflow-hidden cursor-default"
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={step.img}
                  alt={step.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-stone-900/90" />
              </div>

              {/* Step number overlay on image */}
              <span
                className="absolute top-4 left-4 text-white/30 text-5xl font-bold leading-none select-none"
                style={{ fontFamily: "'Cormorant Garamond', serif" }}
              >
                {step.num}
              </span>

              {/* Content below image */}
              <div className="bg-stone-800 group-hover:bg-stone-700 transition-colors duration-300 p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-7 h-7 flex items-center justify-center">
                    <i className={`${step.icon} text-lg text-amber-400`}></i>
                  </div>
                  <h3
                    className="text-white text-lg font-medium"
                    style={{ fontFamily: "'Cormorant Garamond', serif" }}
                  >
                    {step.title}
                  </h3>
                </div>
                <p
                  className="text-stone-400 text-xs leading-relaxed"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  {step.desc}
                </p>
                <div className="mt-5 w-6 h-px bg-amber-500 group-hover:w-12 transition-all duration-500"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
